/** Códigos de erro do módulo de quantitativo (Fase 14). */
export const TAKEOFF_ERROR = {
  INVALID_DIMENSION: 'TAKEOFF.INVALID_DIMENSION',
  INVALID_HEIGHT: 'TAKEOFF.INVALID_HEIGHT',
  ROOM_NAME_REQUIRED: 'TAKEOFF.ROOM_NAME_REQUIRED',
  ROOM_NAME_TAKEN: 'TAKEOFF.ROOM_NAME_TAKEN',
  ROOM_NOT_FOUND: 'TAKEOFF.ROOM_NOT_FOUND',
  BATHROOM_CANNOT_BE_JOINED: 'TAKEOFF.BATHROOM_CANNOT_BE_JOINED',
  WALL_SIDES_IDENTICAL: 'TAKEOFF.WALL_SIDES_IDENTICAL',
  WALL_NOT_FOUND: 'TAKEOFF.WALL_NOT_FOUND',
  POSITION_NOT_ALLOWED: 'TAKEOFF.POSITION_NOT_ALLOWED',
  POSITION_COUNT_INVALID: 'TAKEOFF.POSITION_COUNT_INVALID',
  UNIT_CODE_TAKEN: 'TAKEOFF.UNIT_CODE_TAKEN',
  ITEM_NOT_ALLOWED: 'TAKEOFF.ITEM_NOT_ALLOWED',
  ITEM_ARC: 'TAKEOFF.ITEM_ARC',
  ROLE_WRONG_DISCIPLINE: 'TAKEOFF.ROLE_WRONG_DISCIPLINE',
  LABOR_UNIT: 'TAKEOFF.LABOR_UNIT',
  INVALID_QUANTITY: 'TAKEOFF.INVALID_QUANTITY',
  OVERRIDE_REASON_REQUIRED: 'TAKEOFF.OVERRIDE_REASON_REQUIRED',
  OPENING_LARGER_THAN_WALL: 'TAKEOFF.OPENING_LARGER_THAN_WALL',
  SERVICE_NAME_REQUIRED: 'TAKEOFF.SERVICE_NAME_REQUIRED',
  SERVICE_NAME_TAKEN: 'TAKEOFF.SERVICE_NAME_TAKEN',
  SERVICE_NOT_FOUND: 'TAKEOFF.SERVICE_NOT_FOUND',
  INVALID_APPLIES_TO: 'TAKEOFF.INVALID_APPLIES_TO',
  ITEM_DESCRIPTION_REQUIRED: 'TAKEOFF.ITEM_DESCRIPTION_REQUIRED',
  ITEM_DUPLICATED: 'TAKEOFF.ITEM_DUPLICATED',
  ROLE_NOT_FOUND: 'TAKEOFF.ROLE_NOT_FOUND',
  NEGATIVE_ITEM_QUANTITY: 'TAKEOFF.NEGATIVE_ITEM_QUANTITY',
  MEASURED_REASON_REQUIRED: 'TAKEOFF.MEASURED_REASON_REQUIRED',
  NEGATIVE_SERVICE_QUANTITY: 'TAKEOFF.NEGATIVE_SERVICE_QUANTITY',
  SERVICE_NOT_MEASURABLE: 'TAKEOFF.SERVICE_NOT_MEASURABLE',
  SERVICE_UNIT_LOCKED: 'TAKEOFF.SERVICE_UNIT_LOCKED',
  INVALID_CONSUMPTION_INDEX: 'TAKEOFF.INVALID_CONSUMPTION_INDEX',
  ITEM_OVERRIDE_REASON_REQUIRED: 'TAKEOFF.ITEM_OVERRIDE_REASON_REQUIRED',
  STEEL_OUTSIDE_CUTTING: 'TAKEOFF.STEEL_OUTSIDE_CUTTING',
  // O apontamento por peça (Fase 27, etapa 6).
  PIECE_ALREADY_EXECUTED: 'TAKEOFF.PIECE_ALREADY_EXECUTED',
  PIECE_NOT_IN_FRONT: 'TAKEOFF.PIECE_NOT_IN_FRONT',
  SERVICE_MEASURES_NO_PIECE: 'TAKEOFF.SERVICE_MEASURES_NO_PIECE',
  // Onde a peça mora (RN-361): o servidor confere o que a tela só esconde.
  PIECE_MISPLACED: 'TAKEOFF.PIECE_MISPLACED',
  // O avanço por cômodo (Fase 34, etapa 1).
  SERVICE_NOT_BY_ROOM: 'TAKEOFF.SERVICE_NOT_BY_ROOM',
  ROOM_NOT_IN_FRONT: 'TAKEOFF.ROOM_NOT_IN_FRONT',
  ROOM_NOT_APPLICABLE: 'TAKEOFF.ROOM_NOT_APPLICABLE',
  INVALID_ROOM_PERCENT: 'TAKEOFF.INVALID_ROOM_PERCENT',
  // O nome novo da peça da planilha (20/10/2026, RN-457).
  IMPORTED_PIECE_NAME_TAKEN: 'TAKEOFF.IMPORTED_PIECE_NAME_TAKEN',
  // A taxa de conversão média (Fase 39, RN-497): a versão nunca entra.
  RATE_AVERAGE_VERSION: 'TAKEOFF.RATE_AVERAGE_VERSION',
} as const;

export const TAKEOFF_ERROR_MESSAGE: Readonly<Record<string, string>> = {
  [TAKEOFF_ERROR.INVALID_DIMENSION]: 'A medida deve ser maior que zero.',
  [TAKEOFF_ERROR.INVALID_HEIGHT]: 'A altura deve ser maior que zero.',
  [TAKEOFF_ERROR.ROOM_NAME_REQUIRED]: 'O nome do ambiente é obrigatório.',
  [TAKEOFF_ERROR.ROOM_NAME_TAKEN]: 'Já existe um ambiente com este nome nesta tipologia.',
  [TAKEOFF_ERROR.ROOM_NOT_FOUND]: 'Ambiente não encontrado.',
  [TAKEOFF_ERROR.BATHROOM_CANNOT_BE_JOINED]:
    'Banheiro não pode ser conjugado: sempre há parede entre ele e o ambiente vizinho.',
  [TAKEOFF_ERROR.WALL_SIDES_IDENTICAL]: 'Uma parede não pode ter o mesmo ambiente dos dois lados.',
  [TAKEOFF_ERROR.WALL_NOT_FOUND]: 'Parede não encontrada.',
  [TAKEOFF_ERROR.OPENING_LARGER_THAN_WALL]: 'O vão não cabe na parede.',
  [TAKEOFF_ERROR.POSITION_NOT_ALLOWED]: 'Este tipo de pavimento não comporta esta tipologia.',
  [TAKEOFF_ERROR.POSITION_COUNT_INVALID]:
    'A quantidade da posição precisa ser um número inteiro de 1 para cima.',
  [TAKEOFF_ERROR.UNIT_CODE_TAKEN]: 'Já existe um apto com este código nesta torre.',
  [TAKEOFF_ERROR.ITEM_NOT_ALLOWED]:
    'Este item não está vinculado a este serviço. Vincule-o na planilha de serviços antes de lançá-lo.',
  [TAKEOFF_ERROR.ITEM_ARC]:
    'A linha é de material ou de mão de obra — nunca das duas, nem de nenhuma.',
  [TAKEOFF_ERROR.ROLE_WRONG_DISCIPLINE]: 'Esta função não executa a disciplina deste serviço.',
  [TAKEOFF_ERROR.LABOR_UNIT]: 'Mão de obra é medida em homem-hora.',
  [TAKEOFF_ERROR.INVALID_QUANTITY]: 'A quantidade deve ser maior que zero.',
  [TAKEOFF_ERROR.SERVICE_NAME_REQUIRED]: 'O nome do serviço é obrigatório.',
  [TAKEOFF_ERROR.SERVICE_NAME_TAKEN]: 'Esta disciplina já tem um serviço com este nome.',
  [TAKEOFF_ERROR.SERVICE_NOT_FOUND]: 'Serviço não encontrado.',
  [TAKEOFF_ERROR.INVALID_APPLIES_TO]:
    'Este elemento não se mede assim. Escolha o elemento e depois uma das medidas que ele aceita.',
  [TAKEOFF_ERROR.OVERRIDE_REASON_REQUIRED]:
    'Divergência de apto precisa de motivo — é o que explica o número diferente seis meses depois.',
  [TAKEOFF_ERROR.ITEM_DESCRIPTION_REQUIRED]: 'O item precisa de uma descrição.',
  [TAKEOFF_ERROR.ITEM_DUPLICATED]:
    'Este serviço já tem este item. O mesmo material não entra duas vezes no mesmo serviço.',
  [TAKEOFF_ERROR.ROLE_NOT_FOUND]: 'Função não encontrada, ou desativada.',
  [TAKEOFF_ERROR.NEGATIVE_ITEM_QUANTITY]:
    'A quantidade não pode ser negativa. Zero é decidir que o item não acontece aqui.',
  [TAKEOFF_ERROR.MEASURED_REASON_REQUIRED]:
    'O desenho mede este serviço: corrigir o número dele precisa de motivo — é o que explica a diferença depois.',
  [TAKEOFF_ERROR.NEGATIVE_SERVICE_QUANTITY]: 'A quantidade do serviço não pode ser negativa.',
  [TAKEOFF_ERROR.SERVICE_NOT_MEASURABLE]:
    'Este serviço ainda não diz de que elemento sai a medida. Escolha o elemento antes de dar número a ele.',
  [TAKEOFF_ERROR.SERVICE_UNIT_LOCKED]:
    'Este serviço já tem medição gravada nesta unidade. Trocar a unidade mudaria o que as medições já feitas querem dizer.',
  [TAKEOFF_ERROR.INVALID_CONSUMPTION_INDEX]:
    'O índice de consumo e a perda não podem ser negativos, e a perda fica abaixo de 1000%.',
  [TAKEOFF_ERROR.ITEM_OVERRIDE_REASON_REQUIRED]:
    'Este item é calculado pelo índice: digitar outro número precisa de motivo — é o que explica a diferença depois.',
  [TAKEOFF_ERROR.STEEL_OUTSIDE_CUTTING]: 'O aço só entra no CORTE E DOBRA DE FERRAGEM.',
  [TAKEOFF_ERROR.PIECE_ALREADY_EXECUTED]:
    'Esta peça já foi executada neste serviço em outro dia. Para refazer, desmarque lá primeiro.',
  [TAKEOFF_ERROR.PIECE_NOT_IN_FRONT]:
    'A peça não é desta frente, ou não é do tipo que o serviço mede.',
  [TAKEOFF_ERROR.SERVICE_MEASURES_NO_PIECE]: 'Este serviço não mede peça: não há o que marcar.',
  [TAKEOFF_ERROR.PIECE_MISPLACED]: 'A peça não cabe nesta tipologia.',
  [TAKEOFF_ERROR.SERVICE_NOT_BY_ROOM]:
    'Este serviço não mede por ambiente: o avanço dele fica no pavimento, e não no cômodo.',
  [TAKEOFF_ERROR.ROOM_NOT_IN_FRONT]: 'O cômodo não é de um apto deste pavimento.',
  [TAKEOFF_ERROR.ROOM_NOT_APPLICABLE]:
    'O cômodo está marcado "não se aplica" neste serviço. Desmarque antes de informar o percentual.',
  [TAKEOFF_ERROR.INVALID_ROOM_PERCENT]: 'O percentual do cômodo vai de 0 a 100.',
  [TAKEOFF_ERROR.IMPORTED_PIECE_NAME_TAKEN]: 'Já existe uma peça com este nome nesta tipologia.',
  [TAKEOFF_ERROR.RATE_AVERAGE_VERSION]:
    'Versão de orçamento não entra na taxa média nem é referência: marque a obra aprovada.',
};
